import { render, staticRenderFns } from "./DlgCampaignNew.vue?vue&type=template&id=0d2d2674&scoped=true&"
import script from "./DlgCampaignNew.vue?vue&type=script&lang=ts&"
export * from "./DlgCampaignNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d2674",
  null
  
)

export default component.exports